import { emails } from "../../constants";

export const terms = Object.freeze({
    connectYourMls: 'Connect your MLS',
    thankYou: 'Thank You!',
    welcomeMessage: "Welcome to AgentMetrics!  Let's get started by connecting your MLS with the system to power the data.",
    yourMLSassociation: 'Your MLS Association',
    mlsAgentId: 'MLS Agent ID',
    saveAndContinue: 'Save & Continue',
    enterYourMlsAgentId: 'Enter your MLS Agent ID',
    selectYourMls: 'Select your MLS',
    verificationErrorP1: `We couldn't verify your credentials.`,
    verificationErrorP2: `Please try again or reach out to ${emails.lwolfSupport} for assitance.`,
    goToLoneWolfHome: 'Go to Lone Wolf Home',
});

export const topPerformerAgents = [
    {
        agentId: '23_261',
        mlsId: 268,
        mlsName: 'ACV',
        name: 'Nicholas Politi',
        officeName: 'Merrill L. Thomas, Inc.',
    },
    {
        agentId: '203024816250737',
        mlsId: 181,
        mlsName: 'AKMLS',
        name: 'Marc Dunne',
        officeName: 'Jack White Commercial',
    },
    {
        agentId: 'R11804',
        mlsId: 43,
        mlsName: 'BACMLS',
        name: 'Jim Allen',
        officeName: 'Coldwell Banker Hpw',
    }
];

export const topPerformerAgentsOptions = topPerformerAgents.map(agent => ({
    label: `${agent.mlsName} - ${agent.name} (Agent ID: ${agent.agentId})`,
    value: agent.agentId,
    mlsId: agent.mlsId,
    agentId: agent.agentId,
    agentName: agent.name,
    officeName: agent.officeName,
}));
